import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from '../auth-layout/auth-layout/auth-layout.component';
import { LoginComponent } from './components/login/login.component';
import { ExpiredInvitationComponent } from '../pages/expired-invitation/expired-invitation.component';
import { UnconfirmedLoginPromptComponent } from './components/unconfirmed-login-prompt/unconfirmed-login-prompt.component';
import { QuestionnaireUserPromptComponent } from './components/questionnaire-user-prompt/questionnaire-user-prompt.component';

const routes: Routes = [
  {
    path: '', component: AuthLayoutComponent, children: [
      { path: '', component: LoginComponent },
      { path: 'unconfirmed', component: UnconfirmedLoginPromptComponent },
      { path: 'questionnaire', component: QuestionnaireUserPromptComponent },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
